module.exports = __webpack_public_path__ + "img/pager2-quick-icon6.b2e2d9d9.png";